<app-summary (expandedEvent)="onExpand()" [expandable]="true">
    <app-datetime-summary-field title  [datetime]="summary.date"></app-datetime-summary-field>
    <ng-container expandedContent>
        <app-loading *ngIf="findOneService.loading$ | async"></app-loading>
        <ng-container *ngIf="plain">
            <app-workflow-task-item *ngFor="let workflowTask of plain.workflowTasks"
                                    [entity]="workflowTask"></app-workflow-task-item>
        </ng-container>
    </ng-container>
</app-summary>
